import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { createContext } from 'react';
const AuthContext = createContext(undefined);
export default AuthContext;
export const AuthProvider = ({ children, loginUserQueryKeys, getLoginUser }) => {
    var _a;
    const useLoginUser = useQuery({
        queryKey: loginUserQueryKeys.index(),
        queryFn: () => getLoginUser(),
        meta: { isErrorHandling: false },
    });
    return (_jsx(AuthContext.Provider, { value: {
            authWaiting: useLoginUser.isLoading,
            user: ((_a = useLoginUser.data) === null || _a === void 0 ? void 0 : _a.user) || null,
            refreshAuth: useLoginUser.refetch,
        }, children: children }));
};
//# sourceMappingURL=AuthProvider.js.map